import { LinearProgress } from "@mui/material";
import React from "react";

interface IContainerProps {
  isLoading: boolean;
  size?: string
  noBorder?: boolean;
}
export const ProgressContainer: React.FC<IContainerProps> = (props) => {
  const maxWidth = props.size ? props.size : "max-w-2xl";

  return (
    <div className={`mx-auto bg-white ${maxWidth} min-w-min ${props.noBorder ? "": "rounded-lg shadow-lg"}`}>
      <LinearProgress className="mb-4" style={{"visibility": props.isLoading? "visible": "hidden"}} />
      <div className="p-1 md:p-6">
        {props.children}
      </div>
    </div>
  );
};
